import { render, staticRenderFns } from "./addCategory.vue?vue&type=template&id=a4666784&"
import script from "./addCategory.vue?vue&type=script&lang=ts&"
export * from "./addCategory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports